;(function() {
  'use strict'

  angular.module('app.core').factory('surveyExplorerSlotsService', Service)

  /* @ngInject */
  function Service() {
    return {
      getValue: getValue,
      getOptions: getOptions,
      setValue: setValue,
      getPinnedCategory: getPinnedCategory,
    }

    // What a variable slot currently shows: 'rows', 'columns', '-' (filters is
    // off the table), or the id of the single item the variable is pinned to.
    function getValue(slots, category, pinnedCategory) {
      if (category === slots.rows) return 'rows'
      if (category === slots.columns) return 'columns'
      if (category === 'filters') return '-'
      if (category === pinnedCategory) return slots.target
      // Unreachable under the <=3-variable invariant (see the slotVariables guard
      // in the component): a non-filters variable is always either on an axis or
      // the single pinned one.
      return null
    }

    // The dropdown options for a variable slot. A variable can only be pinned to
    // a single item when two other variables remain to fill the rows and columns
    // axes, so the per-item options only show when there are 3+ variables.
    function getOptions(category, categories, items) {
      var options = [
        { id: 'rows', label: 'Rows' },
        { id: 'columns', label: 'Columns' },
      ]
      var canPin = categories.length >= 3
      if (!canPin) return options
      if (category === 'filters') {
        options.push({ id: '-', label: '-' })
      } else {
        items.forEach(function(item) {
          options.push({ id: item.id, label: item.label })
        })
      }
      return options
    }

    // Apply a slot change and return the new { rows, columns, target }.
    // pinnedCategory is the variable currently pinned to an item (or null);
    // items maps each variable to its [{ id, label }] list.
    function setValue(slots, category, value, pinnedCategory, items) {
      var rows = slots.rows
      var columns = slots.columns
      var target = slots.target

      // move the variable onto the rows or columns axis
      if (value === 'rows' || value === 'columns') {
        var axis = value
        var other = axis === 'rows' ? 'columns' : 'rows'
        if (slots[axis] === category) {
          return { rows: rows, columns: columns, target: target } // already here
        }
        if (slots[other] === category) {
          // the variable is on the other axis: swap the two axes over
          if (axis === 'rows') {
            rows = category
            columns = slots.rows
          } else {
            columns = category
            rows = slots.columns
          }
        } else {
          // the variable was off the table: it takes the axis, and whatever was
          // on that axis is set aside ('-' for filters, otherwise pinned)
          var displaced = slots[axis]
          if (axis === 'rows') rows = category
          else columns = category
          target =
            displaced === 'filters' ? null : firstItemId(items, displaced)
        }
        return { rows: rows, columns: columns, target: target }
      }

      // set filters aside (off the table); the pinned variable takes its axis
      if (value === '-') {
        if (pinnedCategory) {
          if (rows === 'filters') rows = pinnedCategory
          else columns = pinnedCategory
        }
        return { rows: rows, columns: columns, target: null }
      }

      // pin the variable to a single item (value is the item id)
      target = value
      var pinnedAxis =
        rows === category ? 'rows' : columns === category ? 'columns' : null
      if (pinnedAxis) {
        // the variable that was off the table moves onto the freed axis
        var aside = pinnedCategory || 'filters'
        if (pinnedAxis === 'rows') rows = aside
        else columns = aside
      }
      return { rows: rows, columns: columns, target: target }
    }

    function firstItemId(items, category) {
      var list = items[category] || []
      return list.length ? list[0].id : null
    }

    // The variable pinned to a single item is the available one not on either
    // axis. Filters can be "off the table" without being pinned, so it never
    // counts. Mirrors how the renderer interprets `target` (by layout, not by
    // the target id's type) so the UI and renderer can never disagree.
    function getPinnedCategory(slots, categories) {
      if (!slots.target) return null
      var offAxis = categories.find(function(category) {
        return category !== slots.rows && category !== slots.columns
      })
      return offAxis && offAxis !== 'filters' ? offAxis : null
    }
  }
})()
